import api from "./api"; // Assumindo que existe um cliente axios/fetch configurado

export interface DashboardResponse {
  period: {
    startDate: string;
    endDate: string;
    groupBy: "day" | "week" | "month";
  };
  indicators: {
    openTickets: number;
    closedTickets: number;
    pendingTickets: number;
    totalMessages: number;
    uniqueContacts: number;
  };
  topContactsByTickets: Array<{
    contactId: number;
    contactName: string;
    count: number;
  }>;
  topContactsByMessages: Array<{
    contactId: number;
    contactName: string;
    count: number;
  }>;
  timeSeries: Array<{
    period: string;
    ticketsCount: number;
    messagesCount: number;
  }>;
}

export interface IndicatorsParams {
  startDate?: string;
  endDate?: string;
}

export interface TimeSeriesParams {
  startDate?: string;
  endDate?: string;
  groupBy?: "day" | "week" | "month";
}

export interface TopContactsParams {
  startDate?: string;
  endDate?: string;
  metric?: "tickets" | "messages";
  limit?: number;
}

class DashboardService {
  /**
   * Buscar dados completos do dashboard
   */
  async getDashboard(params: {
    startDate?: string;
    endDate?: string;
    groupBy?: "day" | "week" | "month";
  }): Promise<DashboardResponse> {
    const response = await api.get("/dashboard-v2", { params });
    return response.data;
  }

  /**
   * Buscar apenas indicadores principais
   */
  async getIndicators(params: IndicatorsParams): Promise<{
    openTickets: number;
    closedTickets: number;
    pendingTickets: number;
    totalMessages: number;
    uniqueContacts: number;
  }> {
    const response = await api.get("/dashboard-v2/indicators", { params });
    return response.data;
  }

  /**
   * Buscar série temporal de tickets e mensagens
   */
  async getTimeSeries(params: TimeSeriesParams): Promise<
    Array<{
      period: string;
      ticketsCount: number;
      messagesCount: number;
    }>
  > {
    const response = await api.get("/dashboard-v2/time-series", { params });
    return response.data;
  }

  /**
   * Buscar ranking de contatos
   */
  async getTopContacts(params: TopContactsParams): Promise<
    Array<{
      contactId: number;
      contactName: string;
      count: number;
    }>
  > {
    const response = await api.get("/dashboard-v2/top-contacts", { params });
    return response.data;
  }
}

export default new DashboardService();
